import React from 'react'
import { Instagram, Tiktok, Youtube } from 'react-bootstrap-icons'

export default function BrandsProviderFilters({ activeProvider, onProviderChange }) {
  const providers = [
    { key: 'all', label: 'All', icon: null },
    { key: 'instagram', label: 'Instagram', icon: Instagram, color: 'text-pink-600' },
    { key: 'tiktok', label: 'TikTok', icon: Tiktok, color: '' },
    { key: 'youtube', label: 'YouTube', icon: Youtube, color: 'text-red-500' },
  ]

  return (
    <div className="flex mr-2">
      {providers.map((provider) => {
        const isActive = (activeProvider === null && provider.key === 'all') || (activeProvider === provider.key && provider.key !== 'all')
        const Icon = provider.icon

        if (provider.key === 'all') {
          return (
            <button
              key={provider.key}
              onClick={() => onProviderChange('all')}
              className={`rounded-lg px-2 py-1 ${
                isActive
                  ? 'bg-rb-light-green dark:bg-rb-green/20 border-rb-green border-2 dark:text-rb-dark-mode'
                  : 'border-1 border-border-primary dark:border-rb-dark-mode-lighter hover:bg-gray-200 dark:hover:bg-rb-dark-mode-lighter'
              } text-rb-mat-grey dark:text-white`}
            >
              All
            </button>
          )
        }

        return (
          <button
            key={provider.key}
            onClick={() => onProviderChange(provider.key)}
            className={`ml-2 rounded-lg p-2 ${
              isActive
                ? 'bg-rb-light-green dark:bg-rb-green/20 border-rb-green border-2 dark:text-rb-dark-mode'
                : 'border-1 border-border-primary dark:border-rb-dark-mode-lighter hover:bg-gray-200 dark:hover:bg-rb-dark-mode-lighter'
            } ${provider.color} ${provider.color === '' ? 'dark:text-white' : ''} ${provider.color === 'text-pink-600' ? 'dark:text-pink-400' : ''} ${provider.color === 'text-red-500' ? 'dark:text-red-400' : ''}`}
            title={provider.label}
          >
            {Icon && <Icon />}
          </button>
        )
      })}
    </div>
  )
}


